/* CUSTOM JV — trust-strip pe mobil: un singur mesaj vizibil, rotit la 4s (fade simplu). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var strips = document.querySelectorAll('.jv-trust');
  if (!strips.length || !mq.matches) return;
  strips.forEach(function (strip) {
    var items = strip.querySelectorAll('.jv-trust__item');
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('is-visible');
    setInterval(function () {
      items[i].classList.remove('is-visible');
      items[i].style.display = '';
      i = (i + 1) % items.length;
      items.forEach(function (el, idx) { el.style.display = idx === i ? 'inline' : 'none'; });
    }, 4000);
  });
})();
